exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.connector[data-v-69aa770e] {\n  background-color: #ffffff;\n  border-radius: 4px;\n  padding: 15px 30px;\n}\n.close-btn[data-v-69aa770e] {\n  position: relative;\n  right: -15px;\n}\n.tooltip-popup[data-v-69aa770e] {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 10;\n  margin-left: -22px;\n  margin-top: 8px;\n  border-radius: 100%;\n  border: 1px solid #353535;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69aa770e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/connectors/AuthConnector.vue
// module id = +RQT
// module chunks = 53